(() => {
  'use strict';
  const data = JSON.parse(document.getElementById('lsa-catalog')?.textContent || '{}');
  const offers = data.offers || {};
  const root = (window.Shopify?.routes?.root || data.root || '/').replace(/\/?$/, '/');
  const money = cents => new Intl.NumberFormat(data.locale || 'de-DE', {style:'currency',currency:data.currency || 'EUR'}).format(Number(cents || 0) / 100);
  const labels = data.labels || {};
  const setVariants = (data.setVariants || []).map(Number);
  const legacyVariants = (data.legacyVariants || []).map(Number);
  const deviceVariant = Number(data.deviceVariant);
  const deviceUnits = item => {
    if(item.selling_plan_allocation || Object.values(item.properties || {}).some(Boolean))return 0;
    const id=Number(item.variant_id || item.id);
    return setVariants.includes(id) ? setVariants.indexOf(id)+1 : legacyVariants.indexOf(id)+1;
  };
  const deviceCount = cart => cart.items.reduce((sum,item)=>sum+deviceUnits(item)*item.quantity,0);
  function deviceUpdates(cart,total) {
    const desired={};
    if(setVariants.length!==3 || setVariants.some(id=>!id))throw new Error(labels.error);
    if(total>=3)desired[setVariants[2]]=Math.floor(total/3);
    if(total%3)desired[setVariants[total%3-1]]=1;
    const updates={};
    for(const item of cart.items){
      if(!deviceUnits(item))continue;
      const id=Number(item.variant_id || item.id), quantity=desired[id] || 0;
      if(item.quantity!==quantity)updates[item.key]=quantity;
      delete desired[id];
    }
    return {...updates,...desired};
  }
  function updateDevices(cart,total){
    const updates=deviceUpdates(cart,total);
    return Object.keys(updates).length ? post('cart/update.js',{updates}) : Promise.resolve(cart);
  }
  function displayDeviceQuantities(){
    document.querySelectorAll('input[data-device-quantity]').forEach(input=>{
      input.value=input.dataset.deviceQuantity;
      // Native form updates count sets; JS controls count devices.
      input.removeAttribute('name');
    });
  }
  let selected = document.querySelector('[data-quick-buybar]')?.dataset.buybarProduct === 'koffer' ? 'koffer' : '1';
  let busy = false, lastFocus = null, toastTimer;
  const drawer = () => document.querySelector('[data-lsa-cart-drawer],.cart-drawer');
  function notify(message) {
    const el=document.querySelector('.toast'); if(!el)return;
    el.textContent=message;el.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>el.classList.remove('show'),5000);
  }
  function modalState() {
    const open=document.body.classList.contains('cart-drawer-open');
    document.querySelectorAll('main,.shopify-section-group-header-group,.shopify-section-group-footer-group,[data-quick-buybar]').forEach(el=>{el.inert=open;});
    const bar=document.querySelector('[data-quick-buybar]');if(bar)bar.inert=open||document.body.classList.contains('menu-open');
  }
  window.lsaSyncModal=modalState;
  function openDrawer(remember=true) {
    const el=drawer();if(!el){location.assign(data.cartUrl||root+'cart');return;}
    if(remember&&!el.contains(document.activeElement)&&document.activeElement!==document.body)lastFocus=document.activeElement;
    el.classList.add('is-open');el.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');modalState();
    requestAnimationFrame(()=>el.querySelector('[data-cart-drawer-close]:not(.cart-drawer__backdrop)')?.focus());
  }
  function closeDrawer() {
    const el=drawer();el?.classList.remove('is-open');el?.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');modalState();
    if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});
  }
  async function json(url, options={}) {
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options,headers:{Accept:'application/json',...options.headers}});
    const result=await response.json();
    if(!response.ok)throw new Error(typeof result.description==='string'?result.description:typeof result.message==='string'?result.message:labels.error);
    return result;
  }
  function post(path, body) {return json(root+path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});}
  async function refreshCart(focusSnapshot=null) {
    const cart=await json(root+'cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const ids=[...new Set(Array.from(document.querySelectorAll('[data-cart-section-id], [data-lsa-cart-drawer]')).map(el=>el.dataset.cartSectionId||el.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','')).filter(Boolean))];
    // Render in the current theme-preview context, not the published cart template.
    const sectionUrl=new URL(window.location.href);
    sectionUrl.hash='';sectionUrl.searchParams.set('sections',ids.join(','));
    // Product URLs negotiate product JSON for Accept: application/json, ignoring sections.
    const sections=await json(sectionUrl.pathname+sectionUrl.search,{cache:'no-store',headers:{Accept:'text/html'}});
    const wasOpen=document.body.classList.contains('cart-drawer-open');
    const {focusKey,focusKind,scopeId,variantId}=focusSnapshot||{};
    let replaced=false;
    for(const id of ids){
      if(typeof sections[id]!=='string')continue;
      const current=document.getElementById('shopify-section-'+id);if(!current)continue;
      const parsed=new DOMParser().parseFromString(sections[id],'text/html');
      const replacement=parsed.getElementById('shopify-section-'+id);
      const content=replacement||parsed.body;
      const panel=current.querySelector('[data-lsa-cart-drawer] .cart-drawer__panel');
      const nextPanel=content.querySelector('[data-lsa-cart-drawer] .cart-drawer__panel');
      if(panel&&nextPanel){
        const scrollTop=panel.querySelector('[data-cart-drawer-body]')?.scrollTop||0;
        panel.innerHTML=nextPanel.innerHTML;
        const body=panel.querySelector('[data-cart-drawer-body]');if(body)body.scrollTop=scrollTop;
      }else current.innerHTML=replacement?replacement.innerHTML:sections[id];
      replaced=true;
    }
    if(wasOpen){const el=drawer();el?.classList.add('is-open');el?.setAttribute('aria-hidden','false');modalState();}
    if(focusKey&&focusKind)requestAnimationFrame(()=>{
      const scope=document.getElementById(scopeId)||drawer();
      let control=scope?.querySelector(focusKind+'[data-line-key="'+CSS.escape(focusKey)+'"]');
      if(!control&&variantId){
        const lines=scope?.querySelectorAll('[data-cart-variant-id="'+CSS.escape(variantId)+'"]');
        if(lines?.length===1)control=lines[0].querySelector(focusKind);
      }
      (control||(wasOpen?drawer()?.querySelector('.cart-drawer__panel'):null))?.focus({preventScroll:true});
    });
    displayDeviceQuantities();
    updateCampaigns();
    if(!replaced){
      // Keep the drawer open if section rendering fails; never reload after a cart edit.
      throw new Error(labels.error);
    }
    return cart;
  }
  async function mutate(work,openAfter=false,source=null) {
    if(busy)return;busy=true;
    const focused=source||document.activeElement;
    const focusSnapshot={focusKey:focused?.dataset.lineKey,focusKind:focused?.hasAttribute('data-lsa-qty')?'[data-lsa-qty="'+focused.dataset.lsaQty+'"]':focused?.matches('input')?'input':null,scopeId:focused?.closest('[id^="shopify-section-"]')?.id,variantId:focused?.closest('[data-cart-variant-id]')?.dataset.cartVariantId};
    const controls=[...document.querySelectorAll('[data-lsa-add],[data-lsa-upgrade],[data-lsa-qty],[data-lsa-remove],input[data-line-key],button[name="checkout"]')].map(el=>[el,el.disabled]);
    controls.forEach(([el])=>el.disabled=true);
    document.querySelectorAll('[data-lsa-cart-error]').forEach(el=>{el.hidden=true;el.textContent='';});
    try{await work();await refreshCart(focusSnapshot);if(openAfter){openDrawer();notify(labels.added);} }
    catch(error){
      const message=error.message||labels.error;notify(message);
      document.querySelectorAll('[data-lsa-cart-error]').forEach(el=>{el.textContent=message;el.hidden=false;});
    }finally{busy=false;controls.forEach(([el,disabled])=>{if(el.isConnected)el.disabled=disabled;});}
  }
  function add(key,form) {
    const offer=offers[key];
    const id=form?.querySelector('[name="id"]')?.value || offer?.id;
    if(!id || (!form&&!offer?.available))return;
    const quantity=Math.max(1,Number(form?.querySelector('[name="quantity"]')?.value||offer?.quantity||1));
    mutate(async()=>{
      if(['1','2','3'].includes(String(key))){
        const cart=await json(root+'cart.js');
        await updateDevices(cart,deviceCount(cart)+Number(key)*quantity);
      }else await post('cart/add.js',{items:[{id:Number(id),quantity}]});
    },true);
  }
  function change(key,quantity,control){
    if(!Number.isInteger(quantity)||quantity<0)return;
    const variantId=Number(control?.closest('[data-cart-variant-id]')?.dataset.cartVariantId);
    mutate(async()=>{
      const cart=await json(root+'cart.js');
      const items=cart.items||[];
      let index=items.findIndex(item=>item.key===key);
      if(index<0&&variantId){
        const matches=items.map((item,index)=>({item,index})).filter(({item})=>Number(item.variant_id||item.id)===variantId);
        if(matches.length===1&&!matches[0].item.selling_plan_allocation&&!Object.values(matches[0].item.properties||{}).some(Boolean))index=matches[0].index;
      }
      if(index<0){await refreshCart();throw new Error(labels.error);}
      const item=items[index];
      if(deviceUnits(item))await updateDevices(cart,deviceCount(cart)-deviceUnits(item)*item.quantity+quantity);
      else await post('cart/change.js',{line:index+1,quantity});
    },false,control);
  }
  document.addEventListener('click',event=>{
    const target=event.target.closest('button,a');if(!target)return;
    if(target.matches('.cart-link,[data-lsa-open-cart]')){event.preventDefault();openDrawer();return;}
    if(target.hasAttribute('data-cart-drawer-close')){event.preventDefault();closeDrawer();return;}
    if(target.hasAttribute('data-lsa-add')){
      if(target.closest('[data-lsa-product-form]')&&target.type==='submit')return;
      event.preventDefault();add(target.dataset.lsaAdd);return;
    }
    if(target.hasAttribute('data-lsa-upgrade')){
      event.preventDefault();const quantity=Number(target.dataset.lsaUpgrade),key=target.dataset.lineKey,variantId=Number(target.dataset.variantId);
      if(!Number.isInteger(quantity)||quantity<2||quantity>3||!key||variantId!==Number(offers['1']?.id))return;
      mutate(async()=>{
        const cart=await json(root+'cart.js');
        const candidates=cart.items.filter(item=>Number(item.variant_id||item.id)===variantId);
        const item=candidates.find(item=>item.key===key)||(candidates.length===1?candidates[0]:null);
        if(candidates.length!==1||!item||item.selling_plan_allocation||Object.values(item.properties||{}).some(Boolean))throw new Error(labels.error);
        if(item.quantity>=quantity)return;
        await updateDevices(cart,deviceCount(cart)-item.quantity+quantity);
      });return;
    }
    if(target.hasAttribute('data-lsa-remove')){event.preventDefault();change(target.dataset.lsaRemove,0,target);return;}
    if(target.hasAttribute('data-lsa-qty')){
      event.preventDefault();const key=target.dataset.lineKey;
      const input=target.closest('[data-lsa-cart-form]')?.querySelector('input[data-line-key="'+CSS.escape(key)+'"]') || document.querySelector('input[data-line-key="'+CSS.escape(key)+'"]');
      if(input)change(key,Number(input.value)+Number(target.dataset.lsaQty)*Number(input.step||1),target);return;
    }
    if(target.hasAttribute('data-buybar-choice')){event.preventDefault();select(target.dataset.buybarChoice==='set'?'1':target.dataset.buybarChoice,true);}
  });
  document.addEventListener('submit',event=>{
    if(event.target.matches('[data-lsa-product-form]')){event.preventDefault();add(event.submitter?.dataset.lsaAdd||selected,event.target);}
  });
  document.addEventListener('change',event=>{
    const input=event.target;
    if(input.matches('input[name="set"]'))select(input.value,false);
    if(input.matches('input[data-line-key]')){
      if(!input.value.trim()||!input.checkValidity()||!Number.isInteger(Number(input.value))||Number(input.value)<0){input.reportValidity();return;}
      change(input.dataset.lineKey,Number(input.value),input);
    }
  });
  document.addEventListener('keydown',event=>{
    if(!document.body.classList.contains('cart-drawer-open'))return;
    if(event.key==='Escape'){event.preventDefault();closeDrawer();}
    if(event.key==='Tab'){
      const nodes=[...drawer().querySelectorAll('.cart-drawer__panel a,.cart-drawer__panel button,.cart-drawer__panel input')].filter(el=>!el.disabled&&el.getClientRects().length);
      const first=nodes[0],last=nodes.at(-1);if(!first)return;
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  function select(key, syncRadio) {
    selected=key;const offer=offers[key];if(!offer)return;
    const bar=document.querySelector('[data-quick-buybar]');
    if(bar){
      bar.dataset.buybarProduct=key==='koffer'?'koffer':'lifesaveair';
      bar.querySelector('.quick-buybar__image').src=offer.image;
      bar.querySelector('.quick-buybar__name').textContent=offer.title;
      bar.querySelector('.quick-buybar__summary').textContent=offer.summary;
      bar.querySelector('.quick-buybar__price strong').textContent=offer.id?money(offer.price):'—';
      const del=bar.querySelector('.quick-buybar__price del');del.hidden=!offer.id||offer.compare<=offer.price;del.textContent=money(offer.compare);
      const saving=bar.querySelector('.quick-buybar__saving');saving.hidden=del.hidden||!offer.discount;saving.textContent=offer.discount;
      const add=bar.querySelector('[data-lsa-add]');add.dataset.lsaAdd=key;add.disabled=!offer.available;
      add.querySelector('[data-add-label]').textContent=offer.available?labels.add:offer.id?labels.unavailable:labels.choose;
      bar.querySelectorAll('[data-buybar-choice]').forEach(button=>{
        const choice=button.dataset.buybarChoice;button.setAttribute('aria-pressed',String(choice===key));
        button.hidden=key==='koffer'?choice!=='koffer'&&choice!=='set':choice==='set';
      });
      bar.dataset.fitKey='';
    }
    const pdp=document.querySelector('[data-lsa-product-kind="device"]');
    if(pdp&&key!=='koffer'){
      const radio=pdp.querySelector('input[name="set"][value="'+key+'"]');if(syncRadio&&radio)radio.checked=true;
      pdp.querySelectorAll('[data-pdp-price],[data-mobile-price]').forEach(el=>el.textContent=offer.id?money(offer.price):'—');
      pdp.querySelectorAll('[data-pdp-compare]').forEach(el=>{el.textContent=money(offer.compare);el.hidden=!offer.id||offer.compare<=offer.price;});
      pdp.querySelectorAll('[data-pdp-discount]').forEach(el=>{el.textContent=offer.discount;el.hidden=!offer.id||offer.compare<=offer.price||!offer.discount;});
      pdp.querySelectorAll('[name="quantity"]').forEach(el=>{el.value=offer.quantity||1;});
      pdp.querySelectorAll('[name="id"]').forEach(el=>{el.value=offer.id||'';el.disabled=!offer.available;});
      pdp.querySelectorAll('[data-lsa-add]').forEach(el=>{el.dataset.lsaAdd=key;el.disabled=!offer.available;el.setAttribute('aria-disabled',String(!offer.available));const label=el.querySelector('[data-lsa-add-label]');if(label)label.textContent=offer.available?(el.dataset.lsaAddText||labels.add):offer.id?(el.dataset.lsaUnavailableText||labels.unavailable):(el.dataset.lsaUnconfiguredText||labels.choose);});
      pdp.querySelectorAll('[data-lsa-stock]').forEach(el=>el.hidden=!offer.available);
    }
    updateBuybar();
  }
  // Texte mit [data-fit-text] einzeilig halten: alle überstehenden gemeinsam verkleinern (min. 8px), erst danach umbrechen. Gibt den kleinsten Anteil an der Ausgangsgröße zurück.
  function fitText(scope){
    const items=[...scope.querySelectorAll('[data-fit-text]')];
    items.forEach(el=>{el.style.fontSize='';el.style.whiteSpace='';});
    const shown=items.filter(el=>el.getClientRects().length),base=new Map(shown.map(el=>[el,parseFloat(getComputedStyle(el).fontSize)]));
    for(let round=0;round<4;round++){
      const over=shown.filter(el=>el.scrollWidth>el.clientWidth+.5).map(el=>[el,el.clientWidth/el.scrollWidth,parseFloat(getComputedStyle(el).fontSize)]);
      if(!over.length)break;
      over.forEach(([el,ratio,size])=>{el.style.fontSize=Math.max(8,Math.floor(size*ratio*10)/10)+'px';});
    }
    shown.forEach(el=>{if(el.scrollWidth>el.clientWidth+.5)el.style.whiteSpace='normal';});
    return Math.min(1,...shown.map(el=>el.style.fontSize?parseFloat(el.style.fontSize)/base.get(el):1));
  }
  let raf=0;
  function updateBuybar(){
    const bar=document.querySelector('[data-quick-buybar]');if(!bar)return;
    const section=document.body.dataset.page==='home'?document.querySelector('.selected-hero'):document.querySelector('[data-lsa-product-section]');
    const header=document.querySelector('.site-header');
    const visible=section&&section.getBoundingClientRect().bottom<=Math.max(0,header?.getBoundingClientRect().bottom||0);
    bar.hidden=!visible;document.body.classList.toggle('has-quick-buybar',!!visible);
    // Muss Text stark schrumpfen (<85 %), blendet .is-compact die Geräte-Symbole aus, damit mehr Platz bleibt.
    if(visible&&bar.dataset.fitKey!==String(innerWidth)){bar.dataset.fitKey=String(innerWidth);bar.classList.remove('is-compact');if(fitText(bar)<.85){bar.classList.add('is-compact');fitText(bar);}}
    document.body.style.setProperty('--quick-buybar-space',visible?Math.ceil(bar.getBoundingClientRect().height+parseFloat(getComputedStyle(bar).bottom)+16)+'px':'0px');modalState();
  }
  function scheduleBuybar(){if(!raf)raf=requestAnimationFrame(()=>{raf=0;updateBuybar();});}
  window.addEventListener('scroll',scheduleBuybar,{passive:true});window.addEventListener('resize',scheduleBuybar);window.addEventListener('load',scheduleBuybar);
  if(window.ResizeObserver){const resize=new ResizeObserver(scheduleBuybar);const bar=document.querySelector('[data-quick-buybar]');if(bar)resize.observe(bar);resize.observe(document.querySelector('main'));}
  const campaignDate = window.lsaCampaignDate;
  function updateCampaigns(){
    const now=Date.now();
    // Streichpreise und Rabatt-Labels ([data-lsa-campaign-price]) nur im Kampagnenzeitraum zeigen; CSS blendet sie sonst aus.
    const html=document.documentElement,campaignStart=campaignDate(html.dataset.lsaCampaignStart,html.dataset.lsaCampaignStartTime),campaignEnd=window.lsaCampaignEnd(html.dataset.lsaCampaignEnd,html.dataset.lsaCampaignEndTime,html.dataset.lsaCampaignExtensions);
    html.classList.toggle('lsa-campaign-live',Number.isFinite(campaignStart)&&Number.isFinite(campaignEnd)&&now>=campaignStart&&now<campaignEnd);
    document.querySelectorAll('[data-deal-banner]').forEach(banner=>{
      const start=campaignDate(banner.dataset.dealStart,banner.dataset.dealStartTime),end=window.lsaCampaignEnd(banner.dataset.dealEnd,banner.dataset.dealEndTime,banner.dataset.dealExtensions);
      const valid=Number.isFinite(start)&&Number.isFinite(end)&&end>start;
      const preview=!!window.Shopify?.designMode;
      banner.hidden=!valid||(!preview&&(now<start||now>=end));
      if(banner.hidden)return;
      let seconds=Math.max(0,Math.floor((preview&&now<start?end-start:end-now)/1000));
      const parts={days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
      banner.querySelectorAll('[data-deal-unit]').forEach(el=>el.textContent=String(parts[el.dataset.dealUnit]).padStart(2,'0'));
    });
  }
  setInterval(()=>{if(!document.hidden)updateCampaigns();},1000);
  document.addEventListener('visibilitychange',updateCampaigns);
  document.addEventListener('shopify:section:load',()=>{updateCampaigns();select(selected,false);});
  document.addEventListener('shopify:section:reorder',scheduleBuybar);
  document.addEventListener('shopify:section:select',event=>{if(event.target.querySelector('[data-lsa-cart-drawer]'))openDrawer();});
  document.addEventListener('shopify:section:deselect',event=>{if(event.target.querySelector('[data-lsa-cart-drawer]'))closeDrawer();});
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshCart().catch(()=>{});});
  const linkedVariant=Number(new URL(location.href).searchParams.get('variant'));
  const linkedKey=Object.keys(offers).find(key=>Number(offers[key].id)===linkedVariant);
  if(linkedKey && document.querySelector('[data-lsa-product-kind="device"]'))selected=linkedKey;
  select(selected,true);updateCampaigns();displayDeviceQuantities();
  // Reconcile existing baskets after a delivery-country change without touching other items.
  if(data.itemCount>0 && deviceVariant && setVariants.every(Boolean) && setVariants.length===3){
    mutate(async()=>{const cart=await json(root+'cart.js');await updateDevices(cart,deviceCount(cart));});
  }
  document.fonts?.ready.then(()=>{const bar=document.querySelector('[data-quick-buybar]');if(bar){bar.dataset.fitKey='';updateBuybar();}});
})();
